define('controllers/exhibition/current',[
	'jquery',
	'widgets/emails',
	'widgets/track',
	'widgets/size',
	'widgets/forward',
], function ($) {

	var view = {

		id: 'exhibition-current',
		ready: false,
		enabled: null,

		setup: function () {

			if (this.ready) return this;

			this.update();

			this.ready = true;
			return this;

		},

		enable: function () {

			if (this.enabled) return this;

			$.subscribe({
			});
			this.$el.addClass('enabled');

			this.enabled = true;
			return this;

		},

		disable: function () {

			if (!this.enabled) return this;

			this.$el.off('.' + this.id);
			$.unsubscribe('.' + this.id);

			this.$el.removeClass('enabled');

			this.enabled = false;
			return this;

		},

		update: function () {

			var $el = $('#' + this.id);

			if (this.$el && this.$el[0] == $el[0])
				return;

			this.$el = $el;

		}

	};

	return view;

});
